import { render, staticRenderFns } from "./RadioWidget.vue?vue&type=template&id=5f9d58cb&lang=pug&"
import script from "./RadioWidget.vue?vue&type=script&lang=js&"
export * from "./RadioWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports